export default __webpack_public_path__ + "static/media/Shadow's Armbands of the Burning Temple.376792dc.jpg";